import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './Slideshow.css';

import {
  slideShowContainer,
  buttonStyle,
  slideShowBodyStyle,
  contentContainerStyle,
  imageStyle,
  closeButtonStyle,
} from './Slideshow_style';

class SlideShow extends React.Component {
  propTypes = {
    showModal: PropTypes.bool,
    onCloseButtonClicked: PropTypes.func,
    imageSrc: PropTypes.array, // Array<String>,
    imageAlt: PropTypes.array, // Array<String>
  };

  constructor(props) {
    super(props);
    const { imageSrc, imageAlt } = this.props;
    this.state = {
      index: 0,
      imageSrc,
      imageAlt,
    };
  }

  componentWillReceiveProps(nextProps) {
    const body = document.getElementsByTagName('body')[0];

    if (nextProps.showModal) {
      const style = document.createElement('style');
      style.id = 'modal_temp_style';
      style.innerHTML = `
        .modal-content {
          background: none;
          box-shadow: none;
        }
      `;
      body.appendChild(style);
    } else {
      const modalStyle = document.getElementById('modal_temp_style');
      if (modalStyle) body.removeChild(modalStyle);
    }
  }

  /**
   *
   */
  render() {
    const { props } = this;
    const { imageSrc, imageAlt, index } = this.state;
    return (
      <Modal
        ref={modal => (this.modal = modal)}
        className="slideshow"
        bsSize="large"
        show={props.showModal}
        style={slideShowContainer}
        dialogClassName={styles.customModal}
        backdropStyle={{ background: 'none' }}
      >
        <div style={{ width: 1050, margin: '0 auto' }}>
          <Modal.Header>
            <Modal.Title className={styles['title-modal']}>
              <div style={{ width: '95%' }}> Bank Statement Guide </div>
              <div style={closeButtonStyle} onClick={this.onClosed.bind(this)}>
                <i className="fa fa-times" />
              </div>
            </Modal.Title>
            {/* x close button */}
          </Modal.Header>
          <Modal.Body style={{ backgroundColor: 'white', height: '88vh' }}>
            <div
              onKeyDown={this.onKeyPress.bind(this)}
              style={{ contentContainerStyle }}
              onClick={SlideShow.onBackgroundClick}
            >
              <div id="slideshow_body_" style={slideShowBodyStyle}>
                <div
                  id="slideshow_button_left"
                  onClick={this.onPrev.bind(this)}
                  style={buttonStyle}
                >
                  <i
                    style={{ marginLeft: -5 }}
                    className="fa fa-chevron-left"
                  />
                </div>
                <div id="slideshow_content_">
                  <div style={{ fontSize: 20, marginBottom: 22 }}>
                    {imageAlt[index]}
                  </div>
                  <div id="slideshow_image_" style={imageStyle}>
                    <img src={imageSrc[index]} alt={imageAlt[index]} />
                  </div>
                </div>
                <div
                  id="slideshow_button_right"
                  onClick={this.onNext.bind(this)}
                  style={buttonStyle}
                >
                  <i className="fa fa-chevron-right" />
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    );
  }

  onKeyPress(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.which === 9) return; // tab
    if (e.which === 27) this.onClosed(e); // esc
    if (e.which === 37) this.onPrev(e); // left
    if (e.which === 39) this.onNext(e); // next
  }

  static onBackgroundClick(e) {
    // capture click and stop propagation to the main component in htm
    e.preventDefault();
    e.stopPropagation();
  }

  onClosed(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onCloseButtonClicked && this.props.onCloseButtonClicked();
  }

  onNext(e) {
    e.preventDefault();
    e.stopPropagation();
    const { index, imageSrc } = this.state;
    if (index >= imageSrc.length - 1) {
      this.setState({ index: 0 });
    } else {
      this.setState({ index: this.state.index + 1 });
    }
  }

  onPrev(e) {
    e.preventDefault();
    e.stopPropagation();
    const { index, imageSrc } = this.state;
    if (index <= 0) {
      this.setState({ index: imageSrc.length - 1 });
    } else {
      this.setState({ index: this.state.index - 1 });
    }
  }
}

export default SlideShow;
